import icon from "../../assets/image-sensor.svg";
import type { Property } from "../../types";

export const imageSensor: Property = {
  id: "imageSensor",
  title: "imageSensor.title",
  icon,
};
